import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "./AuthProvider";
import PageLayout from "./PageLayout";

export default function SavedPage() {
  const { session } = useAuth();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  console.log("Running fetchData");

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/saved" });

    const fetchData = async () => {
      if (!session) return;

      setLoading(true);

      const { data, error } = await supabase
        .from("user_recommendations")
        .select(`
          recommendation_id,
          recommendations (
            id,
            name,
            url,
            image_url,
            category,
            recommender,
            episode_id,
            episodes (
              id,
              name,
              date,
              show_id,
              shows (
                id,
                name
              )
            )
          )
        `)
        .eq("user_id", session.user.id);

      if (!data || data.length === 0) {
        setRecords([]);
        setLoading(false);
        return;
      }

      if (error) {
        console.error("Error fetching saved recommendations:", error.message);
        setLoading(false);
        return;
      }

      const parsed = data.map((r) => {
        const rec = r.recommendations;
        const ep = rec.episodes;
        const show = ep?.shows;

        return {
          id: rec.id,
          fields: {
            id: rec.id,
            Title: ep?.name || "",
            Date: ep?.date || "",
            Recommendation: rec.name || "",
            Link: rec.url || "",
            ImageUrl: rec.image_url || "",
            Category: rec.category?.split(",").map(c => c.trim()) || [],
            // super bad code here
            Recommender: Array.isArray(show?.name) ? show.name : [show?.name].filter(Boolean),
            Show: Array.isArray(show?.name) ? show.name : [show?.name].filter(Boolean),
          }
        };
      });

      setRecords(parsed);
      setLoading(false);
    };

    fetchData();
  }, [session]);

  if (!session) {
    return (
      <div style={{ textAlign: "center", marginTop: "4rem" }}>
        <p>You need to log in to view your saved recommendations!</p>
      </div>
    );
  }
  

  return (
    <PageLayout
    title="Saved Recs"
    records={records}
    loading={loading}
    hasRecommender={true}
    filterKeys={["Category", "Show"]}
    hideSort={true}
    />
  );
}